// extracted by mini-css-extract-plugin
export default {"filterBtn":"columnConfig_filterBtn__NgFWz"};